import React, { Component } from 'react';

import { Layout, Card } from 'antd';
const { Content } = Layout;

class HomeScreen extends Component {
  render() {
    return (
      <Content style={{ margin: '24px 16px 0' }}>
        {/* <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Přehled</h2>
        </div> */}
      </Content>
    );
  }
}

export default HomeScreen;



// WEBPACK FOOTER //
// ./src/screens/HomeScreen.js